import { repository, baseURL } from "@/api/base"

export default {
  async getCatalog() {
    const { data } = await repository.get(baseURL + '/submissionSession/findAll')
    return data
  },

  async getCatalogPagination(page = 0, size = 10, year) {
      const params = new URLSearchParams({
          page: page,
          size: size
      })
      
      if (year) {
          params.append('year', year)
      }
      
      const { data } = await repository.get(baseURL + '/submissionSession', { params })
      return data
  },

  async create(body) {
    const { data } = await repository.post(baseURL + '/submissionSession', body)
    return data
  },

  async update(body) {
    const { data } = await repository.put(baseURL + '/submissionSession', body)
    return data
  },

  async remove(id) {
    return await repository.delete(baseURL + '/submissionSession/' + id)
  }
}
